import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LANGUAGE } from "../../i18n";

interface I18nTextProps {
	className?: string;
	enText: string;
	cnText: string;
	children?: React.ReactNode;
}

const I18nText: React.FC<I18nTextProps> = ({ className, enText, cnText, children }) => {
	const { i18n } = useTranslation();

	return useMemo(() => {
		if (i18n.language === LANGUAGE.CN) {
			return (
				<span className={className}>
					{cnText}
					{children}
				</span>
			);
		}

		return (
			<span className={className}>
				{enText}
				{children}
			</span>
		);
	}, [i18n.language, enText, cnText]);
};

export default memo(I18nText);
